import React, { useEffect, useState } from "react";
import { ChevronRight } from "lucide-react";
import BrandImage from "../common/BrandImage";
import { fetchPublishedTournaments, liveScoresButton } from "../../utils/liveScores";

const HeroSection = () => {
  const [live, setLive] = useState(null);

  // An additional button only while a tournament is published; nothing extra if the fetch fails.
  useEffect(() => {
    const ctrl = new AbortController();
    fetchPublishedTournaments({ signal: ctrl.signal }).then((tournaments) => {
      if (!ctrl.signal.aborted) setLive(liveScoresButton(tournaments));
    });
    return () => ctrl.abort();
  }, []);

  return (
    <section id="home" className="smym-hero">
      <div
        className="smym-hero__bg"
        style={{
          "--smym-hero-png": 'url("/photos/group-pic.png")',
          "--smym-hero-webp": 'url("/photos/group-pic.webp")',
          "--smym-hero-webp-mobile": 'url("/photos/group-pic-1280.webp")',
        }}
        aria-hidden
      />
      <div className="smym-hero__wash" aria-hidden />

      <div className="smym-hero__inner">
        <div className="smym-hero__content">
          <h1 className="smym-hero__title smym-display">
            Shree Maheshwari Yuva{" "}
            <span className="smym-hero__name-end">
              Mandal, <span className="smym-hero__city-inline">Chennai</span>
            </span>
          </h1>

          <div className="smym-hero__logo-wrap">
            <BrandImage
              src="/smym-hd-no-bg.png?v=20261103"
              alt="Shree Maheshwari Yuva Mandal, Chennai"
              className="smym-hero__logo"
            />
          </div>

          <div className="smym-hero__ctas">
            {live ? (
              <a
                href={live.href}
                className="smym-btn smym-hero__btn smym-hero__btn-live"
              >
                <span className="smym-live-dot" aria-hidden />
                <span className="smym-hero__btn-live-label">{live.label}</span>
                <ChevronRight className="h-5 w-5 shrink-0" aria-hidden />
              </a>
            ) : null}
            <button
              type="button"
              className="smym-btn smym-btn-primary smym-hero__btn smym-hero__btn-register"
              onClick={() => {
                window.location.href = "/member-registration";
              }}
            >
              Become a SMYM member
              <ChevronRight className="h-5 w-5 shrink-0" aria-hidden />
            </button>
            <a href="#events" className="smym-btn smym-hero__btn smym-hero__btn-quiz">
              Upcoming events
              <ChevronRight className="h-5 w-5 shrink-0" aria-hidden />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
